import { shellyKeyWords, jsKeyWords } from './docs/js-script';

export interface AutoCompleteOption {
	title: string;
	icon: string;
	event?: string;
	params?: string;
	type?: string;
	parent?: string;
	returns?: any;
}

export const AutoCompleteIcons = {
	methods: '<i class="far fa-function"></i>',
	params: '<i class="far fa-cube"></i>',
	list: '<i class="far fa-list"></i>',
	shelly: '<svg viewBox="0 0 24 24" height="12" width="12"><path fill="#2491ff" d="M12 0C5.373 0 0 5.373 0 12a12 12 0 0 0 .033.88c1.07-.443 2.495-.679 4.322-.679h5.762c-.167.61-.548 1.087-1.142 1.436-.532.308-1.14.463-1.823.463h-.927c-.89 0-1.663.154-2.32.463-.859.403-1.286 1-1.286 1.789 0 .893.59 1.594 1.774 2.1a7.423 7.423 0 0 0 2.927.581c1.318 0 2.416-.29 3.297-.867 1.024-.664 1.535-1.616 1.535-2.857 0-.854-.325-2.08-.976-3.676-.65-1.597-.975-2.837-.975-3.723 0-2.79 2.305-4.233 6.916-4.324.641-.01 1.337-.005 1.916-.004.593 0 1.144.05 1.66.147A12 12 0 0 0 12 0zm4.758 5.691c-1.206 0-1.809.502-1.809 1.506 0 .514.356 1.665 1.067 3.451.71 1.787 1.064 3.186 1.064 4.198 0 2.166-1.202 3.791-3.607 4.875-1.794.797-3.892 1.197-6.297 1.197-1.268 0-2.442-.114-3.543-.316A12 12 0 0 0 12 24c6.627 0 12-5.373 12-12a12 12 0 0 0-.781-4.256 3.404 3.404 0 0 1-.832.77h-4.371l1.425-2.828a299.94 299.94 0 0 0-2.683.005Z"></path></svg>',
};

const autoCompleteOptions: AutoCompleteOption[] = [
	{
		title: 'function',
		icon: AutoCompleteIcons.methods,
	},
	{
		title: 'if',
		event: `if ()`,
		icon: AutoCompleteIcons.list,
	},
	{
		title: 'else if',
		event: `else if ()`,
		icon: AutoCompleteIcons.list,
	},
	{
		title: 'else',
		event: `else {}`,
		icon: AutoCompleteIcons.list,
	},
];

export const getKeyWordsHighlight = (shelly = false, exclParams = false): string[] => {
	let specialKeyWords = [];
	const autoKeyWords = shelly ? shellyKeyWords : jsKeyWords;
	for (const k in autoKeyWords) {
		if (exclParams && /^(methods|params)$/.test(k)) {
			continue;
		}
		if (k.startsWith('new ')) {
			specialKeyWords.push(k);
			continue;
		}
		const methods =
				k == 'methods' ? autoKeyWords?.methods : Object.keys(autoKeyWords[k]?.methods || {}),
			params = k == 'params' ? autoKeyWords?.params : Object.keys(autoKeyWords[k]?.params || {}),
			members = [...methods, ...params];
		for (const i in members) {
			specialKeyWords.push(`${/^(methods|params)$/.test(k) ? '' : k + '.'}${members[i]}`);
		}
	}
	return shelly ? specialKeyWords : [...autoCompleteOptions.map((i) => i.title), ...specialKeyWords];
};

export const getKeyWords = (): AutoCompleteOption[] => {
	return [
		...autoCompleteOptions,
		..._getKeyWords(shellyKeyWords, AutoCompleteIcons.shelly),
		..._getKeyWords(shellyKeyWords.methods, AutoCompleteIcons.shelly, true),
		..._getKeyWords(jsKeyWords, AutoCompleteIcons.list),
		..._getKeyWords(jsKeyWords.methods, AutoCompleteIcons.methods, true),
		..._getKeyWords(jsKeyWords.params, AutoCompleteIcons.params),
	];
};

const _getKeyWords = (keyWords, icon: string, method = false): AutoCompleteOption[] => {
	const keywords = [],
		members = Array.isArray(keyWords) ? keyWords : Object.keys(keyWords);
	for (const k in members) {
		const title = members[k];
		if (!/^(methods|params)$/.test(title)) {
			keywords.push({
				title,
				event: method ? `${title}()` : title,
				icon,
			});
		}
	}
	return keywords;
};
